import { captureException as sentryCaptureException } from '@/common/config/sentry';

const handleException = (error: unknown | Error, context?: Record<string, unknown>) => {
  // Always log to console in development
  // eslint-disable-next-line no-console
  console.error(error, context);

  // Send to Sentry in production
  if (import.meta.env.PROD) {
    sentryCaptureException(error, context);
  }
};

export default handleException;
